module.exports = __webpack_public_path__ + "static/media/business.998bb24b.jpg";